import { Map, List, fromJS } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    selectedAddressFromPredictions: null,

    selectedAddress: null,
    selectedStore: null,

    selectedTempAddress: null,
    selectedTempStoreDetails: null,

    addressFromGeoLocationSuccess: false,
    addressFromGeoLocationFailed: null,

    addressFromPlaceIdSuccess: false,
    addressFromPlaceIdFailed: null,

    uspsValidatedAddress: Map(),
    uspsValidatedAddressSuccess: false,
    uspsValidatedAddressFailed: null,

    alcoholRestrictions: null,
    showAlcoholSalesHour: false,
    deliveryStores: List([]),
    gettingDeliveryStoresInProgress: false,

    pickupStores: List([]),
    gettingPickupStores: false,
    settingPickupStoreDetails: false,

    gettingStoreDetails: null,
    storeDetails: null,

    savedAddresses: null,
    saveUserAddressSuccess: false,
    saveUserAddressFailed: null,
    recentAddresses: List([]),
    isAddressDeliverable: null,
    storeNearUser: [],
    addressProcessing: false,
    countryForGlobalAssortment: null,
    choiceButton: null,
    enteredAddress: null,

    showClearCartMessage: null,
})

export default (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.ADDRESS_PROCESSING_DONE: {
            return state.merge({
                addressProcessing: true,
            })
        }

        case actions.DISPLAY_ALCOHOL_RESTRICTION_MODAL: {
            return state.merge({
                showAlcoholSalesHour: payload,
            })
        }

        case actions.FILTER_STORES_COMPLETE: {
            return state.merge({
                storeNearUser: payload,
            })
        }
        case actions.GET_PLACE_DETAILS_FAILED: {
            return state.merge({
                addressFromPlaceIdSuccess: false,
                addressFromPlaceIdFailed: true,
            })
        }

        case actions.SET_IS_ADDRESS_DELIVERABLE: {
            return state.merge({
                isAddressDeliverable: payload,
            })
        }
        case actions.SET_COUNTRY_FOR_GLOBAL_ASSORTMENT: {
            return state.merge({
                countryForGlobalAssortment: payload,
            })
        }

        case actions.UPDATE_ADDRESS_FOR_PICKUP: {
            return state.merge({
                selectedAddress: fromJS(payload),
                saveUserAddressSuccess: true,
                saveUserAddressFailed: false,
            })
        }

        case actions.GET_PLACE_DETAILS_SUCCESS: {
            return state.merge({
                addressFromPlaceIdSuccess: true,
                addressFromPlaceIdFailed: false,
            })
        }

        case actions.GET_ADDRESS_FROM_COORDINATES_SUCCESS: {
            return state.merge({
                addressFromGeoLocationSuccess: true,
                addressFromGeoLocationFailed: false,
            })
        }

        case actions.GET_ADDRESS_FROM_COORDINATES_FAILED: {
            return state.merge({
                addressFromGeoLocationSuccess: false,
                addressFromGeoLocationFailed: true,
            })
        }

        case actions.SET_ALCOHOL_RESTRICTIONS: {
            return state.merge({
                alcoholRestrictions: fromJS(payload),
            })
        }

        case actions.VALIDATE_USPS_SUCCESS: {
            return state.merge({
                uspsValidatedAddress: fromJS(payload),
                uspsValidatedAddressSuccess: true,
                uspsValidatedAddressFailed: false,
            })
        }

        case actions.VALIDATE_USPS_FAILED: {
            return state.merge({
                uspsValidatedAddressSuccess: false,
                uspsValidatedAddressFailed: true,
            })
        }

        case actions.GET_STORES_BY_LOCATION: {
            return state.merge({
                gettingDeliveryStoresInProgress: true,
                alcoholRestrictions: null,
            })
        }

        case actions.GET_STORES_BY_LOCATION_SUCCESS: {
            return state.merge({
                deliveryStores: fromJS(payload),
                gettingDeliveryStoresInProgress: false,
            })
        }

        case actions.GET_STORES_BY_LOCATION_FAILED: {
            return state.merge({
                gettingDeliveryStoresInProgress: false,
                deliveryStores: List([]),
            })
        }

        case actions.GET_PICKUP_STORES: {
            return state.merge({
                gettingPickupStores: true,
            })
        }

        case actions.PICKUP_STORES_SUCCESS: {
            return state.merge({
                gettingPickupStores: false,
                pickupStores: payload,
            })
        }

        case actions.PICKUP_STORES_FAILED: {
            return state.merge({
                gettingPickupStores: false,
                pickupStores: List([]),
            })
        }

        case actions.GET_STORE_DETAILS: {
            return state.merge({
                gettingStoreDetails: true,
            })
        }

        case actions.GET_STORE_DETAILS_SUCCESS: {
            return state.merge({
                gettingStoreDetails: false,
                storeDetails: fromJS(payload),
            })
        }

        case actions.GET_STORE_DETAILS_FAILED: {
            return state.merge({
                gettingStoreDetails: false,
                storeDetails: null,
            })
        }

        case actions.SET_STORE_DETAILS: {
            return state.merge({
                selectedStore: fromJS(payload),
            })
        }

        case actions.SET_ADDRESS: {
            return state.merge({
                selectedAddress: fromJS(payload),
            })
        }

        case actions.SET_SAVED_ADDRESSES: {
            return state.merge({
                savedAddresses: fromJS(payload),
            })
        }

        case actions.SET_TEMP_ADDRESS: {
            return state.merge({
                selectedTempAddress: fromJS(payload),
            })
        }

        case actions.SET_TEMP_STORE_DETAILS: {
            return state.merge({
                selectedTempStoreDetails: fromJS(payload),
            })
        }

        case actions.TRANSFER_TEMP_TO_SELECTED: {
            const address = state.get('selectedTempAddress')
            const storeDetails = state.get('selectedTempStoreDetails')
            if (address) {
                return state.merge({
                    selectedTempAddress: null,
                    selectedTempStoreDetails: null,
                    selectedAddress: address,
                    selectedStore: storeDetails,
                })
            }
            return state
        }

        case actions.FILTER_STORE_COMPLETE: {
            return state.merge({
                nearestPickupStores: payload,
            })
        }

        case actions.SET_CHOICE_BUTTON: {
            return state.merge({
                choiceButton: payload,
            })
        }

        case actions.SET_ENTERED_ADDRESS: {
            return state.merge({
                enteredAddress: payload,
            })
        }

        case actions.RESET_ENTERED_ADDRESS: {
            return state.merge({
                enteredAddress: null,
            })
        }

        case actions.RESET_STORE_DETAILS: {
            return state.merge({
                gettingStoreDetails: null,
            })
        }

        case actions.SET_CLEAR_CART: {
            return state.merge({
                showClearCartMessage: payload,
            })
        }

        default:
            return state
    }
}
